import React, { useEffect, useState } from "react";
import axios from "axios";

function formatWithUnits(value, decimals = 1) {
  if (value == null || isNaN(value)) return "—";
  const sign = value < 0 ? "-" : "";
  const abs = Math.abs(value);

  let out;
  if (abs >= 1e9) out = (abs / 1e9).toFixed(decimals) + "B";
  else if (abs >= 1e6) out = (abs / 1e6).toFixed(decimals) + "M";
  else out = abs.toLocaleString(undefined, { maximumFractionDigits: 2 });

  // strip trailing .0
  out = out.replace(/(\.\d*?[1-9])0+$|\.0+($|[^0-9])/g, "$1$2");
  return sign + out;
}

function SummaryStats({ entity, filterMetrics = [] }) {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/financials/${entity}`)
      .then((res) => {
        const filteredData = res.data.filter(
          (row) => filterMetrics.length === 0 || filterMetrics.includes(row.Metric)
        );

        const grouped = filteredData.reduce((acc, row) => {
          const key = row.Metric;
          if (!acc[key]) acc[key] = [];
          acc[key].push(Number(row.Value)); // ensure numeric
          return acc;
        }, {});

        const summary = Object.entries(grouped).map(([metric, values]) => {
          const latest = values[values.length - 1];
          const avg = values.reduce((a, b) => a + b, 0) / values.length;
          return { metric, latest, avg };
        });

        setStats(summary);
      });
  }, [entity, filterMetrics]);

  return (
    <div className="bg-white rounded p-4 shadow-md mb-6">
      <h2 className="text-lg font-semibold mb-2 text-gray-700">Summary Statistics</h2>
      <ul className="space-y-2">
        {stats.map(({ metric, latest, avg }) => (
          <li key={metric} className="text-sm text-gray-800">
            <strong>{metric}</strong>: Latest = {formatWithUnits(latest)}, Average = {formatWithUnits(avg)}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SummaryStats;
